import {
  API,
  BlockAPI,
  BlockTool,
  BlockToolConstructorOptions,
} from "@editorjs/editorjs";
import "./index.css";
import type { FaqConfig, FaqData } from "./types";
import Ui from "./ui";

type FaqToolConstructorOptions = BlockToolConstructorOptions<
  FaqData,
  FaqConfig
>;

export class FaqTool implements BlockTool {
  private api: API;

  private block: BlockAPI;

  private config: FaqConfig;

  private ui: Ui;

  private _data: FaqData;

  static get toolbox() {
    return {
      title: "FAQ",
      icon: Ui.toolBoxIcon,
    };
  }

  constructor({
    data,
    config,
    api,
    readOnly,
    block,
  }: FaqToolConstructorOptions) {
    this._data =
      Object.keys(data).length === 0
        ? {
            title: "Frequently Asked Questions",
            faqs: [
              {
                id: crypto.randomUUID(),
                question: "",
                answer: "",
              },
            ],
          }
        : data;
    this.config = config ?? {};
    this.api = api;
    this.block = block;
    this.ui = new Ui({ data: this._data, api, config: this.config, readOnly });
  }

  public render(): HTMLElement {
    return this.ui.render();
  }

  private set data(data: FaqData) {
    this._data = data;
  }

  private get data(): FaqData {
    return this._data;
  }

  public save() {
    this.data = this.ui.getUiData;
    return this.data;
  }

  static get enableLineBreaks() {
    return true;
  }

  static get contentless() {
    return false;
  }

  static get isReadOnlySupported() {
    return true;
  }

  public static get pasteConfig() {
    return {
      tags: ["DIV"],
    };
  }
}
